export default {
	logging_out: 'Signing out. . .',
	message: {
		hello: 'Hello World!',
	},
	loan_status: {
		disapprove_title: 'Application was disapproved!',
		no_remark: 'No remarks. Please contact the administrator.',
	},
	member: {
		menu: {
			loan_applications: {
				calculations: 'Loans Application Calculations'
			}
		},
		inquiry: {
			loan_application_status: {
				oops_title: 'Oops!',
				oops_text: 'There are no applied loans available.'
			},
			loan_application_calculation: {
				title: 'Loans Application Calculations',
				oops_title: 'Oops!',
				oops_text: 'There are no calculations available.'
			},
			loan_application: {
				status: {
					pending_for_approval: 'Peding for Approval',
					click_more_info: 'Click here to see more information.',
					changes_to_loan: 'Click here to check the modification.',

					information: {
						card1_amount: 'Amount',
						card1_principal_amt: 'Principal Amount',
						card1_ammortization: 'Ammortization Amount',
						card1_monthly_interest: 'Monthly Interest',
						card2_title: 'Approver Information',
						card2_person_name: 'Person Name',
						card2_granted_amt: 'Granted Amount',
						card2_granted_term: 'Granted Term',
						card2_payment_mode: 'Payment Mode',
						card2_paystyle: 'Paystyle',
						card2_interest_rate: 'Interest Rate',
						card2_disbuse_date: 'Disbursement Date',
						card2_firs_install_date: 'First Installment Date',
						card2_maturity_date: 'Maturity Date',
						card2_maturity_date: 'Maturity Date',
						card2_remarks: 'Remarks',
						card2_confirm_msg: 'The system is waiting for your approval regarding on the modification suggest by the validator incharge.',
						card2_btn_confirm_modif: 'Confirm Modification',
						confirm_title: 'Are you sure?',
						confirm_text: 'Would you like to confirm the granted information for the loan you are applying?',
						confirm_btn: 'Yes, Confirm Modification!',
						confirm_success_title: 'Modification Approved!',
						confirm_success_text: 'Modification was successfully approved.',
						title: 'Loan Application Status Information',
						fetching: 'Fetching loan information. . .',
						oops_title: 'Oops Sorry!',
						oops_text: 'Something wen\'t wrong while feching information.',
					}
				},
				calculation: {
					title: 'Loans Application Calculations',
					oops_title: 'Oops!',
					oops_text: 'There are no calculations available.'
				}
			}
		}
	},
	coop: {
		loan_applications: {
			detail: {
				approve_info_no_modification: 'Approve without any modification.',
				approve_info_wait_for_member_accept: 'Waiting for member to accept the modification have made.',
				approve_info_title: 'APPROVE INFORMATION',
				approve_info_personal: 'Personnel',
				approve_info_paystyle: 'Paystyle',
				approve_info_granted_payment: 'Granted Mode of Payment',
				approve_info_granted_term: 'Granted Term',
				approve_info_granted_amount: 'Granted Amount',
				approve_info_granted_interest: 'Granted Interest Rate',
				approve_info_disbursement_date: 'Disbursement Date',
				approve_info_first_installment_date: 'First Installment Date',
				approve_info_maturity_date: 'Maturity Date',
				approve_info_approve_type: 'Approve Type',
				approve_info_remarks: 'Remarks upon Approval',

				approver_interest_rate_error: 'The interest rate field is not valid format (100.00).',
				approving_text: 'Sending approval. . .',
				approve_success_title: 'Application Approved!',
				approve_success_text: 'Loan application was successfully approved.',

				receive_text: 'Changing status to receiving. . .',
				receive_success_title: 'Application Receive!',
				receive_success_text: 'Application status was change received.',

				validating: 'Changing status to validated. . .',
				validate_success_title: 'Application Validated!.',
				validate_success_text: 'Application status was chang to validated.',

				disbursing: 'Changing status to disbursement. . .',
				disbursement_success_title: 'Application Validated!.',
				disbursement_success_text: 'Application status was chang to validated.',

				disapprove_remark_title: 'Remark (required)',

				generating_copy: 'Generating loan application summary. . .',
				getting_printed_promisory_note: 'Generating printed copy. . .',
			}
		},
		staff_mgt: {
			saving_staff: 'Adding roles to member. . .',
			staff_added_text: '{name} was successfully added.',
			staff_added_title: 'Staff Added!.',
		},
		payments: {
			approving: (ctx) => `Approving payment of ${ctx.named('name')}. . .`,
			posted_title: 'Payment Posted!',
			posted_text: (ctx) => `${ctx.named('name')} payment was successfully posted.`,
			rejecting: (ctx) => `Rejecting payment of ${ctx.named('name')}. . .`,
			reject_title: 'Payment Rejected!',
			reject_text: (ctx) => `${ctx.named('name')} payment was successfully rejected.`,
		}
	}
}